<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col">
                        <div class="card-header-title">
                            <span class="mdi mdi-vector-intersection mr-2 text-muted"></span> Section Templates
                        </div>
                    </div>
                    <div class="col">
                        <div class="float-right">
                            <button class="btn btn-light btn-sm pt-0 pb-0" v-if="viewMode == 'Kanban'" @click=toggleViewMode()>
                                <span class="mdi mdi-table text-muted" style="font-size: 1.3em;"></span> View as Table
                            </button>
                            <button class="btn btn-light btn-sm pt-0 pb-0" v-if="viewMode == 'Table'" @click=toggleViewMode()>
                                <span class="mdi mdi-periodic-table mdi-rotate-180 text-muted" style="font-size: 1.3em;"></span> View as Chart
                            </button>
                            <button class="btn btn-primary btn-sm ml-2" @click="openSectionCreate">
                                <span class="mdi mdi-plus"></span> Add Section Template
                            </button>
                        </div>                        
                    </div>
                </div>
            </div>

            <div class="card-body">

                <!-- 'Kanban' view -->
                <div class="row" v-if="viewMode == 'Kanban'">
                    <div class="col section-col pt-2 mt-2" v-for="type in availableReportTypes" :key="type.code">
                        <div class="section-col-header mb-2">
                            <h6>{{ type.name }} ({{ type.code }})</h6>
                        </div>
                        
                        <div class="alert alert-light section-card mb-2" :style="getSectionCardBorder(section)" v-for="section in type.sections" :key="section.number">
                            <!-- <p class="mb-0">{{ section.number }} {{ section.name }}</p> -->
                            <router-link :to="{ name: 'report-section-template-edit', params: { sectionId: section.section_id } }">
                                {{ section.number }} {{ section.name }}
                            </router-link>
                        </div>
                    </div>                    
                </div>
                <!-- /'Kanban' view -->

                <div v-if="viewMode == 'Table'">
                    <b-table ref="sectionTable"
                        hover small striped borderless
                        :items="sections"
                        :fields="sectionFields"
                        v-if="sections && sections.length && viewState == 'Idle'">
                        <template v-slot:cell(_name)="data">
                            {{ data.item.name }}
                            <span class="color-code-sticker" :style="'background: ' + data.item.color_code" v-if="data.item.color_code"></span>
                        </template>

                        <template v-slot:cell(_tagged_types)="data">
                            <span style="margin-right: 2px;" v-for="(taggedType, idx) in data.item.report_types" :key="idx">
                                <span class="badge badge-secondary" style="font-weight: 500;">{{ taggedType }}</span>
                            </span>
                        </template>

                        <template v-slot:cell(_actions)="data">
                            <router-link class="btn btn-primary btn-sm float-right mr-1" :to="{ name: 'report-section-template-edit', params: { sectionId: data.item.section_id } }">
                                <span class="mdi mdi-file-document-edit-outline"></span>  Edit
                            </router-link>
                        </template>
                    </b-table>
                </div>

                <!-- Loading info -->
                <div class="d-flex d-flex justify-content-center mt-5 mb-5" v-if="viewState == 'Busy'">
                    <b-spinner variant="secondary" style="width: 1.8rem; height: 1.8rem;"></b-spinner>
                </div>
                <!-- /Loading info -->
            </div>
        </div>

        <div v-if="viewState == 'Error'">
            <div class="alert alert-danger">
                Something went wrong loading your data, please try again. 
                If the problem persists, please contact the support team.
            </div>
        </div>

        <b-modal id="modal-add-section"
            modal-ok
            no-close-on-backdrop
            ok-title="Save"
            title="New Section Template"
            :ok-disabled="!newSectionIsValid"
            @ok="onAddSectionOK">

            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" v-model="newSection.name" placeholder="E.g. Garage/Outbuildings">
            </div>

            <div class="form-group">
                <label>Number</label>
                <input type="text" class="form-control" v-model="newSection.number" placeholder="E.g. 4.4">
            </div>

            <div class="form-group">
                <label>Category</label>
                <input type="text" class="form-control" v-model="newSection.category" placeholder="E.g. The Property">
            </div>
        </b-modal>
    </div>
</template>

<script>
    import SectionTemplateService from '../../../services/templates/sectionTemplateService'
    import ReportTypeService from '../../../services/templates/reportTypeService'

    export default {
        data() {
            return {
                viewState: 'Idle',
                error: null,
                sections: null,
                availableReportTypes: null,
                newSection: { },
                viewMode: 'Kanban',
                sectionFields: [
                    { key: 'number', label: '#', tdClass: 'td-report-type' },
                    { key: '_name', label: 'Name', tdClass: 'td-report-type' },
                    { key: 'category', label: 'Category', tdClass: 'td-report-type' },
                    { key: '_tagged_types', label: 'Report Types', tdClass: 'td-report-type' },
                    { key: '_actions', label: ' ' }
                ]
            }
        },
        async mounted() {
            this.viewState = 'Busy'
            try {
                let sectionsSource = await SectionTemplateService.getReportSectionTemplates()
                this.sections = this.$_.orderBy(sectionsSource.map((s) => {
                    return { ...s, fNumber: parseFloat(s.number) }
                }), [ 'fNumber', 'asc' ])

                console.log(this.sections)

                let availableReportTypes = await ReportTypeService.getReportTypes()
                
                this.availableReportTypes = availableReportTypes
                this.availableReportTypes.forEach((t) => {
                    t.sections = this.sections.filter((s) => {
                        return s.report_types.indexOf(t.code) > -1
                    })
                })

                this.sections.forEach((s) => {
                    let taggedTypes = s.report_types
                    s.report_types = []

                    for (let index = 0; index < availableReportTypes.length; index++) {
                        if (taggedTypes.indexOf(availableReportTypes[index].code) > -1) {
                            s.report_types.push(availableReportTypes[index].code)
                        }
                    }
                })

                this.viewState = 'Idle'
            } catch (err) {
                this.viewState = 'Error'
                this.error = err
                console.error(err)
            }
        },
        computed: {
            newSectionIsValid() {
                return this.newSection.name && this.newSection.category && this.newSection.number
            }
        },
        methods: {
            getSectionCardBorder(section) {
                if (!section.color_code || section.color_code == '#FFFFFF' || section.color_code == '#FFF') {
                    return 'border: 1px solid #ccc; border-left: 6px solid #ccc;'
                }
                else {
                    return `border: 1px solid ${section.color_code}; border-left: 6px solid ${section.color_code};`
                }
            },
            toggleViewMode() {
                let newMode = this.viewMode == 'Kanban' ? 'Table' : 'Kanban'
                this.viewMode = newMode
            },
            openSectionCreate() {
                this.newSection = { }
                this.$bvModal.show('modal-add-section')
            },
            async onAddSectionOK(bvEvt) {
                bvEvt.preventDefault()
                try {
                    let createResult = await SectionTemplateService.createReportSection(this.newSection)
                    this.$router.push({
                        name: 'report-section-template-edit',
                        params: {
                            sectionId: createResult.section_id,
                            isCreateResult: true
                        }
                    })
                } catch (err) {
                    console.error(err)
                    this.$bvToast.toast('Sorry, something went wrong and we couldn\'t save the template', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }

                this.$bvModal.show('modal-add-section')
            }
        }
    }
</script>

<style lang="scss">
    .td-report-type {
        line-height: 32px;
    }

    .color-code-sticker {
        margin-left: 4px;
        display: inline-block;  
        width: 20px;
        height: 20px;
        border-radius: 8px;
    }

    .section-col:nth-child(even) {
        background: rgba(0, 0, 0, 0.075);        
    }

    .section-col {
        .section-col-header {
            height: 40px;
            text-align: center;
        }

        .section-card {
            a {
                color: #333;
                width: 100%;
                display: block;
            }

            a:hover {
                color: #208bc9;
            }
        }
    }    
</style>